import request from "@/utils/request";

export function getGrcRequirements(params) {
  return request({
    url: "/grc-requirements",
    method: "get",
    params,
  });
}

export function getGrcRequirement(id, params) {
  return request({
    url: `/grc-requirements/${id}`,
    method: "get",
    params,
  });
}

export function createGrcRequirement(data, params) {
  return request({
    url: "/grc-requirements",
    method: "post",
    data,
    params,
  });
}

export function updateGrcRequirement(id, data, params) {
  return request({
    url: `/grc-requirements/${id}`,
    method: "put",
    data,
    params,
  });
}

export function approveGrcRequirement(id, data, params) {
  return request({
    url: `/grc-requirements/${id}/approve`,
    method: "post",
    data,
    params,
  });
}

export function rejectGrcRequirement(id, data, params) {
  return request({
    url: `/grc-requirements/${id}/reject`,
    method: "post",
    data,
    params,
  });
}

export function deleteGrcRequirement(id, params) {
  return request({
    url: `/grc-requirements/${id}`,
    method: "delete",
    params,
  });
}
